import {
  createRequest,
  getRequests,
  getRequestById,
} from '../services/api';
import { sanitizeForm, validators } from '../utils/security';

// ── Create a new part request ──
export const handleCreateRequest = async (rawForm, captchaToken = '', images = []) => {
  const form = sanitizeForm(rawForm, {
    brand: 80, model: 80, year: 4, fuel: 30, gear: 30,
    engine: 40, doors: 2, drive: 30, power: 10, chassis_no: 17,
    category: 100, subcategory: 100, part_name: 150,
    description: 1000, full_name: 100, phone: 20, email: 254,
  });

  // Validate required fields
  if (!form.brand)     return { error: 'Lütfen araç markasını seçin.' };
  if (!form.model)     return { error: 'Lütfen araç modelini seçin.' };
  if (!form.year)      return { error: 'Lütfen yıl seçin.' };
  if (!form.category)  return { error: 'Lütfen parça kategorisini seçin.' };
  if (!form.part_name) return { error: 'Lütfen parça seçin.' };
  if (!form.full_name || form.full_name.length < 2)
    return { error: 'Ad soyad en az 2 karakter olmalıdır.' };
  if (!validators.phone(form.phone))
    return { error: 'Geçerli bir telefon numarası girin.' };
  if (!validators.email(form.email))
    return { error: 'Geçerli bir e-posta adresi girin.' };
  if (form.chassis_no && !validators.vin(form.chassis_no))
    return { error: 'Geçerli bir şasi numarası girin (17 karakter).' };

  try {
    let payload;
    if (images && images.length) {
      // Multipart so we can attach photo files.
      payload = new FormData();
      Object.entries(form).forEach(([k, v]) => payload.append(k, v ?? ''));
      payload.append('captcha_token', captchaToken);
      images.slice(0, 5).forEach(file => payload.append('images', file));
    } else {
      payload = { ...form, captcha_token: captchaToken };
    }
    const res = await createRequest(payload);
    return { success: true, data: res.data };
  } catch (err) {
    const errors = err.response?.data?.errors;
    if (errors) {
      const first = Object.values(errors)[0];
      return { error: Array.isArray(first) ? first[0] : first };
    }
    return { error: 'Talep gönderilemedi. Lütfen tekrar deneyin.' };
  }
};

// ── Get all requests (for dashboard) ──
export const handleGetRequests = async (params = {}) => {
  try {
    const res = await getRequests(params);
    return { success: true, data: res.data };
  } catch (err) {
    return { error: 'Talepler yüklenemedi.' };
  }
};

// ── Get single request ──
export const handleGetRequest = async (id) => {
  try {
    const res = await getRequestById(id);
    return { success: true, data: res.data };
  } catch (err) {
    return { error: 'Talep bulunamadı.' };
  }
};